import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {
  parseJSONWithBetterErrors,
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation} from '@github-ui/react-query'
import {useMarkersActions, usePullRequestBasePath} from '../stores/selectors'
import type {FileKey, LineKey} from '@github-ui/diff-lines/types'
import type {HIDE_OPTIONS} from '@github-ui/commenting/HideCommentActions'

export type HideCommentMutationResponse = {
  commentDatabaseId: number
  threadId: number
  reason: HIDE_OPTIONS
}

/**
 * hides a comment for a specific reason
 */
export function useHideCommentMutation(filePath: string, lineMarkersKey: LineKey | FileKey) {
  const basePath = usePullRequestBasePath()
  const apiUrl = `${basePath}/page_data/${PageData.hideComment}`
  const {updateThreadComment} = useMarkersActions()

  return useMutation({
    mutationFn: async ({commentDatabaseId, reason}: {commentDatabaseId: number; reason: string}) => {
      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          classifier: reason,
          commentId: commentDatabaseId,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: (data: HideCommentMutationResponse) => {
      updateThreadComment({
        threadID: data.threadId,
        filePath,
        lineMarkersKey,
        match: storedComment => storedComment.databaseId === data.commentDatabaseId,
        transform: oldComment => {
          if (oldComment) {
            return {...oldComment, isHidden: true, minimizedReason: data.reason}
          }
        },
      })
    },
  })
}
